import React, { useState } from "react";
import { ChevronRight, Clock } from "lucide-react";
import { StatePill } from "./StatePill";
import { TestFlow } from "./TestFlow";
import { ResultView } from "./ResultView";
import { daysUntil } from "../../lib/testLibrary";

const CTA = { pending: "Comenzar", overdue: "Comenzar", in_progress: "Continuar", awaiting_result: "Anotar resultado", repeat_requested: "Repetir prueba" };

const DueHint = ({ a }) => {
  const d = daysUntil(a.due_date);
  const txt = d > 3 ? `Próxima evaluación en ${d} días` : d > 0 ? `Se aproxima: en ${d} día${d > 1 ? "s" : ""}` : d === 0 ? "Prevista para hoy" : `Prevista hace ${-d} día${d < -1 ? "s" : ""}`;
  return <div style={{ fontSize: 12, color: d <= 0 ? "#facc15" : "#a3a3a3", marginTop: 8 }} data-testid={`my-ta-due-${a.id}`}>{txt}</div>;
};

const Card = ({ a, onOpen, onDetail }) => {
  const t = a.template;
  const cta = a.status === "active" ? CTA[a.state] : null;
  const last = a.last_result;
  return (
    <div className="qv-card-app" style={{ padding: 16, marginBottom: 10 }} data-testid={`my-ta-${a.id}`}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "flex-start" }}>
        <div>
          <div style={{ fontWeight: 800, fontSize: 16 }}>{t.label || t.name}</div>
          <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 2 }}>{t.capacity || ""}{t.capacity ? " · " : ""}Fecha {a.due_date}{t.duration_min ? <> · <Clock size={11} style={{ verticalAlign: -1 }} /> {t.duration_min} min</> : ""}</div>
        </div>
        <StatePill s={a.state} player testid={`my-ta-state-${a.id}`} />
      </div>
      {a.state === "repeat_requested" && (a.repeat_request?.round === a.round ? a.repeat_request.comment : last?.review_comment) && <div style={{ fontSize: 13, color: "#f87171", marginTop: 8 }} data-testid={`my-ta-repeat-${a.id}`}>Tu entrenador: {a.repeat_request?.round === a.round ? a.repeat_request.comment : last.review_comment}</div>}
      {a.status === "active" && ["pending", "overdue", "repeat_requested"].includes(a.state) && <DueHint a={a} />}
      {a.state === "needs_setup" && <div style={{ fontSize: 12, color: "#a3a3a3", marginTop: 8 }}>Tu entrenador está terminando de preparar esta prueba.</div>}
      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        {cta && a.state !== "needs_setup" && <button className="qv-btn-primary" style={{ flex: 1, padding: "12px", display: "flex", justifyContent: "center", gap: 6, alignItems: "center" }} onClick={() => onOpen(a)} data-testid={`my-ta-start-${a.id}`}>{cta} <ChevronRight size={16} /></button>}
        {a.results?.length > 0 && <button className="qv-btn-ghost" style={{ padding: "12px", flex: cta ? 0 : 1 }} onClick={() => onDetail(a)} data-testid={`my-ta-detail-${a.id}`}>Resultados</button>}
      </div>
    </div>
  );
};

export const MyAssignedTests = ({ data, reload }) => {
  const [flow, setFlow] = useState(null);
  const [detail, setDetail] = useState(null);
  const active = data.assignments.filter((a) => a.status === "active");
  const retired = data.assignments.filter((a) => a.status !== "active" && a.results?.length);
  if (!active.length && !retired.length) return <div className="qv-empty" data-testid="my-assigned-empty">Tu entrenador todavía no te ha asignado tests.</div>;
  return (
    <div style={{ marginBottom: 26 }} data-testid="my-assigned-tests">
      {active.map((a) => <Card key={a.id} a={a} onOpen={setFlow} onDetail={(x) => setDetail(detail?.id === x.id ? null : x)} />)}
      {detail && (
        <div className="qv-card-app" style={{ padding: 16, marginBottom: 10 }} data-testid="my-ta-results">
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Resultados · {detail.template.label || detail.template.name}</div>
          {[...detail.results].reverse().map((r) => <ResultView key={r.id} r={r} comparison={r.comparison} testid={`my-ta-res-${r.id}`} />)}
        </div>
      )}
      {retired.length > 0 && <><div style={{ fontSize: 12, color: "#737373", margin: "14px 0 8px" }}>Tests ya no activos (historial)</div>{retired.map((a) => <Card key={a.id} a={a} onOpen={setFlow} onDetail={setDetail} />)}</>}
      {flow && <TestFlow a={flow} onClose={(changed) => { setFlow(null); if (changed) reload(); }} />}
    </div>
  );
};
